























































import Field from "@/components/basic/fields/Field.vue";
import Select from "@/components/basic/fields/Select.vue";
import Vue from "vue";
import NoTinField from "@/components/compositeFields/NoTinField.vue";
import TaxOfficeListField from "@/components/compositeFields/TaxOfficeListField.vue";
import TheCountrySelect from "@/components/basic/fields/TheCountrySelect.vue";
import { FieldInterface, TaxResidenceFieldInterface, TaxResidenceDataResponseInterface } from "@/types";
import { TaxResidenceFlags } from "@/constants/tax-residence-flags";
import { mapState } from "vuex";
import PolandTaxResidenceField from "@/components/compositeFields/PolandTaxResidenceField.vue";

export default Vue.extend({
  name: "TaxResidenceField",
  props: {
    name: String,
    passDefaultTaxCountry: {
      type: String,
      default: ""
    },
    countryDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TaxField,
      formDataChanged: false as boolean,
      openTinDetails: true as boolean,
      taxOfficeDataForeigner: {},
      isPolandTaxCountry: false as boolean,
      isNumericalTIN: false,
      formData: {
        taxCountry: "",
        tinNumber: "",
        noTinNumber: "",
        noTinNumberReason: "",
        noTinNumberOtherReason: "",
        polandTaxOfficeId: "",
        polandTaxOfficeName: "",
        polandTaxResidentPesel: "",
      } as TaxResidenceFieldInterface,
      TRANSLATION_KEY: "compositeFields.TaxResidenceField",
    };
  },
  mounted(): void {
    this.setTaxCountry();
  },
  methods: {
    setTaxCountry(): void {
      const { country, onBoardingAction, taxResidenceFlag } = this.taxResidenceData;
      if (this.passDefaultTaxCountry !== "") {
        this.formData.taxCountry = this.passDefaultTaxCountry;
      }
      if (taxResidenceFlag && !onBoardingAction
        && taxResidenceFlag === TaxResidenceFlags.FOREIGNER_LIVE_ABROAD
        && this.name === TaxField.FIRST_TAX_RESIDENCE)
      {
        this.formData.taxCountry = country;
      }

      this.setNumericalTIN()
    },
    mergeFormData(data: object): void {
        this.formData = Object.assign(this.formData, data);

        this.formDataChanged = !this.formDataChanged;
        for (const [key, value] of Object.entries(data)) {
            if (key === 'noTinNumber' && value === true) {
                this.formData.tinNumber = "";
            }
        }
    },
    receiveDataPL(data: object) {
      for (const [key, value] of Object.entries(data)) {
        (this as any).formData[key] = value;
      }
      this.$emit("input", this.formData);
    },

    setNumericalTIN() {
      const numericCountries =  'at, be, bg, cz, de, dk, ee, fr, gr, hr, hu, lt, lv, pl, pt, ro, se, si, sk, us, nl, lu'
      this.isNumericalTIN = numericCountries.includes(this.formData.taxCountry.toLowerCase())
    }
  },
  watch: {
    formDataChanged(): void {
      this.$emit("input", this.formData);
    },
    "formData.taxCountry"(): void {
      this.formDataChanged = !this.formDataChanged;
      this.isPolandTaxCountry = this.formData.taxCountry === 'PL';
      //@TODO check if necessary
      if(this.tinCountries.includes(this.formData.taxCountry)) {
        this.formData.noTinNumber = "";
      }
      this.setNumericalTIN()
    },
    "formData.tinNumber"(): void {
      this.formDataChanged = !this.formDataChanged;
    },
    "formData.noTinNumber"(): void {
      this.formData.noTinNumberReason = ""
      this.formData.noTinNumberOtherReason = ""
    }
  },
  components: {
    PolandTaxResidenceField,
    NoTinField,
    Field,
    Select,
    TaxOfficeListField,
    TheCountrySelect,
  },
  computed: {
    ...mapState({
      countries: (state: any): FieldInterface[] => state.config.countries,
      taxResidenceData: (state: any): TaxResidenceDataResponseInterface => state.formData,
      tinCountries: (state: any) => state.config.tinCountries,
    }),
  },
});

enum TaxField {
    FIRST_TAX_RESIDENCE = "first",
    SECOND_TAX_RESIDENCE = "second",
}
